const headerItem = `<br /><h3>Don't Miss Out On Black Friday Deals</h3>`;
const blackFridayLocalDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/local-black-friday" target="_blank">Black Friday Local Deals Near Me</a></li>';
const blackFridaySpaDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-spa" target="_blank">Black Friday Spa Deals</a></li>';
const blackFridayBelfastDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-northern-ireland" target="_blank">Black Friday Belfast Deals</a></li>';
const blackFridayBirminghamDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-birmingham" target="_blank">Black Friday Birmingham Deals</a></li>';
const blackFridayLondonDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-london" target="_blank">Black Friday London Deals</a></li>';
const blackFridayManchesterDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-manchester" target="_blank">Black Friday Manchester Deals</a></li>';
const blackFridayDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-deals" target="_blank">Black Friday Deals</a></li>';
const blackFridayiPadDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-ipad-deals" target="_blank">Black Friday iPad Deals</a></li>';
const blackFridayiPhoneDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-iphone-deals" target="_blank">Black Friday iPhone Deals</a></li>';
const blackFridayAppleDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-apple-deals" target="_blank">Black Friday Apple Deals</a></li>';
const blackFridayMacbookDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/macbook-deals" target="_blank">Black Friday Macbook Deals</a></li>';
const blackFridayAirFryerDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/air-fryers-health-fryers-deep-fat-fryers" target="_blank">Black Friday Air Fryer Deals</a></li>';
const blackFridayAirpodsDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-airpods-earbuds" target="_blank">Black Friday Airpods Deals</a></li>';
const blackFridayiMacDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/cheap-imacs" target="_blank">Black Friday iMac Deals</a></li>';
const blackFridayLaptopsDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-laptop-deals" target="_blank">Black Friday Laptop Deals</a></li>';
const blackFridayMattressDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-mattress-deals" target="_blank">Black Friday Mattress Deals</a></li>';
const blackFridayEmmaDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/emma-mattress" target="_blank">Emma Mattress Black Friday Deals</a></li>';
const blackFridayTabletDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-tablets" target="_blank">Black Friday Tablet Deals</a></li>';
const blackFridayTechDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-tech-deals" target="_blank">Black Friday Tech Deals</a></li>';
const blackFridaySamsungDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/samsung-sale" target="_blank">Black Friday Samsung Deals</a></li>';
const blackFridayMakeupDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-makeup-beauty-deals" target="_blank">Black Friday Make Up & Beauty Deals</a></li>';
const blackFridayFashionDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-clothing-fashion-deals" target="_blank">Black Friday Fashion Deals</a></li>';
const blackFridayOnesieDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/onesies" target="_blank">Onesies & Snuggies Black Friday Deals</a></li>';
const blackFridayBlanketDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/oversized-blanket-hoodies" target="_blank">Blanket Hoodies Black Friday Deals</a></li>';
const blackFridayFurnitureDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-home-deals" target="_blank">Black Friday Home Furniture & Decoration Deals</a></li>';
const blackFridayJewelleryDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-jewellery-deals" target="_blank">Black Friday Jewellery Deals</a></li>';
const blackFridayToyDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-toy-deals" target="_blank">Black Friday Toy & Kids Deals</a></li>';
const blackFridayPerfumeDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-perfume-deals" target="_blank">Black Friday Perfume Deals</a></li>';
const blackFridayWatchDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-watches" target="_blank">Black Friday Watch Deals</a></li>';
const blackFridayVacuumDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/dyson-vacuum-sale" target="_blank">Dyson Vacuum Black Friday Deals</a></li>';
const blackFridayHooverDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-vacuum-cleaners" target="_blank">Black Friday Vacuum & Hoover Deals</a></li>';
const blackFridayFlightsDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-holidays-flights" target="_blank">Black Friday Holiday Deals</a></li>';
const blackFridayHotelDeal =
  '<li><a href="https://www.wowcher.co.uk/guides/black-friday-hotel" target="_blank">Black Friday Hotel Deals</a></li>';
const isLocal = ({ dealDescription, router }) => {
  return (
    router?.asPath?.includes('activities-entertainment') ||
    (router?.asPath?.includes('afternoon-tea') &&
      router?.asPath?.includes('food-drink') &&
      !dealDescription.includes('local-black-friday'))
  );
};

const appendElectricalsLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('tablets')) {
    if (!dealDescription.includes('black-friday-ipad-deals')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayAppleDeal} ${blackFridayTechDeal} ${blackFridaySamsungDeal} ${blackFridayiPadDeal} ${blackFridayTabletDeal}`;
    }
  } else if (router?.asPath?.includes('mobile-phones')) {
    if (!dealDescription.includes('black-friday-iphone-deals')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayAppleDeal} ${blackFridayTechDeal} ${blackFridaySamsungDeal} ${blackFridayiPhoneDeal}`;
    }
  } else if (router?.asPath?.includes('computing')) {
    if (!dealDescription.includes('macbook-deals')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayAppleDeal} ${blackFridayTechDeal} ${blackFridaySamsungDeal} ${blackFridayMacbookDeal} ${blackFridayiMacDeal} ${blackFridayLaptopsDeal}`;
    }
  } else if (router?.asPath?.includes('headphones')) {
    if (!dealDescription.includes('black-friday-airpods-earbuds')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayAppleDeal} ${blackFridayTechDeal} ${blackFridaySamsungDeal} ${blackFridayAirpodsDeal}`;
    }
  } else if (!dealDescription.includes('black-friday-apple-deals')) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayAppleDeal} ${blackFridayTechDeal} ${blackFridaySamsungDeal}`;
  }

  return dealDescription;
};

const appendHomeLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('kitchen-appliances')) {
    if (!dealDescription.includes('air-fryers-health-fryers-deep-fat-fryers')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayFurnitureDeal} ${blackFridayAirFryerDeal}`;
    }
  } else if (router?.asPath?.includes('beds-mattresses')) {
    if (
      !dealDescription.includes('black-friday-mattress-deals') ||
      !dealDescription.includes('emma-mattress')
    ) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayFurnitureDeal} ${blackFridayMattressDeal} ${blackFridayEmmaDeal}`;
    }
  } else if (router?.asPath?.includes('cleaning-home-maintenance')) {
    if (
      !dealDescription.includes('dyson-vacuum-sale') ||
      !dealDescription.includes('black-friday-vacuum-cleaners')
    ) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayFurnitureDeal} ${blackFridayVacuumDeal} ${blackFridayHooverDeal}`;
    }
  } else if (!dealDescription.includes('black-friday-home-deals')) {
    return `${dealDescription} ${headerItem}${blackFridayDeal} ${blackFridayFurnitureDeal}`;
  }

  return dealDescription;
};

const appendFashionLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('cosywear-nightwear')) {
    if (
      !dealDescription.includes('onesies') ||
      !dealDescription.includes('oversized-blanket-hoodies')
    ) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayFashionDeal} ${blackFridayOnesieDeal} ${blackFridayBlanketDeal}`;
    }
  } else if (!dealDescription.includes('black-friday-clothing-fashion-deals')) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayFashionDeal}`;
  }

  return dealDescription;
};

const appendBeautyLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('spa')) {
    if (!dealDescription.includes('black-friday-spa')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayMakeupDeal} ${blackFridaySpaDeal}`;
    }
  } else if (router?.asPath?.includes('perfumes')) {
    if (!dealDescription.includes('black-friday-perfume-deals')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayMakeupDeal} ${blackFridayPerfumeDeal}`;
    }
  } else if (!dealDescription.includes('black-friday-makeup-beauty-deals')) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayMakeupDeal}`;
  }

  return dealDescription;
};

const appendJewellryLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('watches')) {
    if (!dealDescription.includes('black-friday-watches')) {
      return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayJewelleryDeal} ${blackFridayWatchDeal} `;
    }
  } else if (!dealDescription.includes('black-friday-jewellery-deals')) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayJewelleryDeal}`;
  }

  return dealDescription;
};

const appendShopLink = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('electricals')) {
    return appendElectricalsLinks({ dealDescription, router });
  } else if (router?.asPath?.includes('home')) {
    return appendHomeLinks({ dealDescription, router });
  } else if (router?.asPath?.includes('fashion')) {
    return appendFashionLinks({ dealDescription, router });
  } else if (router?.asPath?.includes('beauty')) {
    return appendBeautyLinks({ dealDescription, router });
  } else if (router?.asPath?.includes('jewellery')) {
    return appendJewellryLinks({ dealDescription, router });
  } else if (
    router?.asPath?.includes('kids') &&
    router?.asPath?.includes('toys') &&
    !dealDescription.includes('black-friday-toy-deals')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal} ${blackFridayToyDeal}`;
  } else if (!dealDescription.includes('black-friday-deals')) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal}`;
  }

  return dealDescription;
};

export const appendBlackFridayLinks = ({ dealDescription, router }) => {
  if (router?.asPath?.includes('shop')) {
    return appendShopLink({ dealDescription, router });
  } else if (
    router?.asPath?.includes('travel') &&
    (!dealDescription.includes('black-friday-holidays-flights') ||
      !dealDescription.includes('black-friday-hotel'))
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayFlightsDeal} ${blackFridayHotelDeal}`;
  } else if (
    router?.asPath?.includes('belfast') &&
    !dealDescription.includes('black-friday-northern-ireland')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayBelfastDeal}`;
  } else if (
    router?.asPath?.includes('birmingham') &&
    !dealDescription.includes('black-friday-birmingham')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayBirminghamDeal}`;
  } else if (
    router?.asPath?.includes('london') &&
    !dealDescription.includes('black-friday-london')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayLondonDeal}`;
  } else if (
    router?.asPath?.includes('manchester') &&
    !dealDescription.includes('black-friday-manchester')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayManchesterDeal}`;
  } else if (isLocal({ dealDescription, router })) {
    return `${dealDescription} ${headerItem} ${blackFridayLocalDeal}`;
  }
  if (
    !dealDescription.includes('black-friday-deals') &&
    !router?.asPath?.includes('travel')
  ) {
    return `${dealDescription} ${headerItem} ${blackFridayDeal}`;
  }

  return dealDescription;
};
